import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';

import {
  closeGuideDrawer,
  goBackInGuideDrawer,
  goForwardInGuideDrawer,
  type GuideDrawerTarget,
  navigateGuideDrawer,
  openGuideDrawer,
  selectGuideDrawer,
} from '../store/guideDrawerSlice';

/** Opens (optionally on a `#id` section) and closes the app-level guide drawer; the public contract for feature links and other projects. */
export function useGuideDrawer() {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectGuideDrawer);
  const open = useCallback(
    (target: GuideDrawerTarget) => {
      dispatch(openGuideDrawer(target));
    },
    [dispatch],
  );
  const close = useCallback(() => {
    dispatch(closeGuideDrawer());
  }, [dispatch]);
  const navigate = useCallback(
    (slug: string, hash: string | undefined, scrollTop: number) => {
      dispatch(navigateGuideDrawer({ slug, hash, scrollTop }));
    },
    [dispatch],
  );
  const back = useCallback(
    (scrollTop: number) => {
      dispatch(goBackInGuideDrawer(scrollTop));
    },
    [dispatch],
  );
  const forward = useCallback(
    (scrollTop: number) => {
      dispatch(goForwardInGuideDrawer(scrollTop));
    },
    [dispatch],
  );
  return {
    state,
    open,
    close,
    navigate,
    back,
    forward,
    canGoBack: state.past.length > 0,
    canGoForward: state.future.length > 0,
  };
}
